import { Injectable } from '@angular/core';

import { IEmailCodeDialogConfig, IEmailCodeDialogResult } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class EmailCodeModalDialogService {
    private readonly selectors = {
        modalDialogOverlay: '[aza-rws-modal-dialog-overlay]',
        modalDialog: '[aza-rws-email-code-dialog]',
        cancelButton: '[aza-rws-modal-dialog-first-button]',
        proceedButton: '[aza-rws-modal-dialog-second-button]',
        emailCode: '[aza-rws-email-code]'
    };

    async showPopupDialog(config: IEmailCodeDialogConfig): Promise<IEmailCodeDialogResult> {
        const modalDialogOverlayEl = document.querySelector(this.selectors.modalDialogOverlay);
        const modalDialogEl = document.querySelector(this.selectors.modalDialog);
        this.showElement(modalDialogOverlayEl);
        this.showElement(modalDialogEl);
        const emailCodeEl = modalDialogEl.querySelector(this.selectors.emailCode) as HTMLInputElement;
        emailCodeEl.value = '';
        const promise = new Promise<IEmailCodeDialogResult>((resolve, reject) => {
            const cancelBtnEl = modalDialogEl.querySelector(this.selectors.cancelButton) as HTMLDivElement;
            const proceedBtnEl = modalDialogEl.querySelector(this.selectors.proceedButton) as HTMLButtonElement;
            cancelBtnEl.onclick = () => resolve(null);
            proceedBtnEl.onclick = () => {
                resolve({ emailCode: emailCodeEl.value });
            };
        });
        return promise;
    }

    hidePopupDialog(): void {
        const modalDialogOverlayEl = document.querySelector(this.selectors.modalDialogOverlay);
        const modalDialogEl = document.querySelector(this.selectors.modalDialog);
        this.hideElement(modalDialogOverlayEl);
        this.hideElement(modalDialogEl);
        const emailCodeEl = modalDialogEl.querySelector(this.selectors.emailCode) as HTMLInputElement;
        emailCodeEl.value = '';
    }

    hideElement(el: Element): void {
        el.classList.add('display-none');
    }

    showElement(el: Element): void {
        el.classList.remove('display-none');
    }
}
